
import { mapState, mapGetters } from 'vuex'
import { types as productTypes } from '~/utils/product-item-type'
import BidForm from '~/components/create-order/buy/bid-form.vue'
import BuyBasketForm from '~/components/create-order/buy/buy-basket-form.vue'
import DirectBuyForm from '~/components/create-order/buy/direct-buy-form.vue'
import BalanceIcon from '~/assets/images/balance-new-icon.svg?inline'
import ShowOrders from '~/components/create-order/show-orders.vue'

export default {
  components: {
    BidForm,
    BuyBasketForm,
    DirectBuyForm,
    BalanceIcon,
    ShowOrders,
  },
  props: {
    itemId: {
      type: [Number, String],
      required: true,
    },
    itemType: {
      type: String,
      required: true,
      validator: (val) => Object.values(productTypes).includes(val),
    },
    maxPurchasable: {
      type: Number,
      default: undefined,
    },
    name: {
      type: String,
      required: true,
    },
    marketAvailability: {
      type: Object,
      required: true,
    },
    orders: {
      type: Object,
      default: null,
    },
    isInModal: {
      type: Boolean,
      default: false,
    },
    itemIsAnchored: {
      type: Boolean,
      default: false,
    },
    price: {
      type: Number,
      default: undefined,
    },
  },
  data() {
    return {
      showBidForm: false,
      showBuyForm: false,
    }
  },
  computed: {
    ...mapState('trader', ['balance']),
    ...mapGetters('trader', ['isLoadingKeyFigures']),

    ...mapGetters('auth', ['isLoggedIn']),

    ...mapGetters('amountVisibility', ['blurAmounts']),

    title() {
      return this.showBidForm
        ? this.$gettext('Place buy order')
        : this.$gettext('Add to Portfolio')
    },

    showButtons() {
      return (
        !this.showBidForm &&
        !this.showBuyForm &&
        !this.$isBasket({ itemType: this.itemType })
      )
    },

    hasSufficientFunds() {
      return this.balance.tradeBalance > this.marketAvailability.priceFrom
    },

    hasSellOrders() {
      return this.orders && this.orders?.sellOrders.length > 0
    },

    sellOrders() {
      return this.hasSellOrders ? this.orders?.sellOrders : []
    },

    showNoStockMessage() {
      return !this.hasSellOrders && this.showButtons
    },

    showTitle() {
      return !this.isInModal
    },

    showHeader() {
      return this.showTitle || this.isLoggedIn
    },

    canPlaceBuyOrder() {
      return (
        this.maxPurchasable === undefined ||
        (typeof this.maxPurchasable === 'number' && this.maxPurchasable > 0)
      )
    },
  },
  methods: {
    openBidForm() {
      this.isLoggedIn
        ? (this.showBidForm = true)
        : this.$emit('open-login-dialog')

      this.$emit('isBidForm', true)
    },

    openBuyForm() {
      this.isLoggedIn
        ? (this.showBuyForm = true)
        : this.$emit('open-login-dialog')
    },

    openBuyBasketForm() {
      this.isLoggedIn
        ? (this.showBuyBasketForm = true)
        : this.$emit('open-login-dialog')
    },

    closeBidForm() {
      this.showBidForm = false

      this.$emit('isBidForm', false)
    },

    closeBuyForm() {
      this.showBuyForm = false
    },
  },
}
